export default __webpack_public_path__ + "moin-app-illus-no-content-muted.eb7cc8960b172ea5260fbc8aa64dd2c7.png";